
import { defineComponent, PropType } from 'vue'
import JrFileView from '@/components/jr-parts/JrFileView.vue'

interface FileInfo {
  file: number
}

/**
 * 添付ファイル表示コンポーネント
 */
export default defineComponent({
  name: 'GeneralAttachedFiles',
  components: {
    JrFileView,
  },
  props: {
    fileList: {
      type: Array as PropType<FileInfo[]>,
      required: true,
    },
  },
})
